import PropTypes from "prop-types";
import React from "react";

const Text = ({
  variant,
  fontSize,
  fontWeight,
  color,
  children,
  className,
  onClick,
  title
}) => {

  const TextStyle = {
    body: "dds-react-typography-body",
    bodySemibold: "dds-react-typography-body-semibold",
    bodyBold: "dds-react-typography-body-bold",
    label: "dds-react-typography-label",
    labelSemibold: "dds-react-typography-label-semibold",
    link: "dds-react-typography-link",
    linkSmall: "dds-react-typography-link-sm",
    labelSmall: 'text-[10px]'
  };

  return (
    <p
      className={`${TextStyle[variant]} ${fontSize} ${fontWeight} ${color} ${className}`}
      title={title}
      onClick={onClick}>
      {children}
    </p>
  );
};

export default Text;

Text.defaultProps = {
  variant: "body",
  fontSize: "",
  fontWeight: "",
  color: "",
  children: '',
  className: '',
  onClick: () => {},
}

Text.propTypes = {
  variant: PropTypes.oneOf(['body', 'bodySemibold', 'bodyBold', 'label', 'labelSemibold', 'link', 'linkSmall']),
  children: PropTypes.node,
  fontSize: PropTypes.string,
  fontWeight: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};
